<template>
  <div>
    <div>
      <!-----------------heading and buttons ---------------------->
      <v-row class="d-flex justify-space-between" flat>
        <v-col cols="12" md="4">
          <h1 class="heading-1">Help Center</h1>
        </v-col>
        <v-col cols="12" md="8">
          <div class="d-flex justify-end">
            <v-card flat class="d-flex align-center">
              <v-dialog
                v-model="organizedialog"
                persistent
                max-width="600"
                style="overflow-y: hidden"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    outlined
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="text_style mr-3 px-9"
                  >
                    Organize
                  </v-btn>
                </template>
                <v-card flat>
                  <div class="mx-5 py-5 d-flex justify-space-between">
                    <div class="d-flex align-center">
                      <span class="h5 mb-1">Organize</span>
                      <v-dialog
                        v-model="newcategorydialog"
                        persistent
                        max-width="450"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="primary"
                            text
                            dark
                            v-bind="attrs"
                            v-on="on"
                            class="text_style"
                          >
                            + Create Category
                          </v-btn>
                        </template>
                        <v-card>
                          <div class="mx-5 py-5 d-flex justify-space-between">
                            <h5 class="text_style">New Category</h5>
                            <v-icon @click="newcategorydialog = false"
                              >mdi-close</v-icon
                            >
                          </div>
                          <div>
                            <v-card color="#F6F8FC" flat class="px-5">
                              <v-form v-model="valid" class="py-8">
                                <v-card
                                  height="115px"
                                  width="115px"
                                  flat
                                  style="
                                    background-color: white;
                                    border: 1px #cfcfcf solid;
                                  "
                                >
                                  <HelpcenterimageUploader />
                                </v-card>

                                <v-container class="mt-4">
                                  <v-text-field
                                    v-model="NameCategory"
                                    :counter="35"
                                    label="Name Category"
                                    required
                                  ></v-text-field>
                                  <v-text-field
                                    class="my-4"
                                    v-model="NameCategory"
                                    :counter="75"
                                    label="Category Description"
                                    required
                                  ></v-text-field>
                                  <v-select
                                    v-model="filterlanguage"
                                    :items="filterLanguageList"
                                    :menu-props="{ maxHeight: '400' }"
                                    label="Language"
                                    multiple
                                  ></v-select>

                                  <v-select
                                    label="Show/Hide in Help Center "
                                    v-model="filterShowhide"
                                    :items="filtershowhideList"
                                  ></v-select>
                                </v-container>
                              </v-form>
                            </v-card>
                          </div>

                          <v-card-actions class="pb-4">
                            <v-spacer></v-spacer>
                            <v-btn
                              class="text_trans"
                              color="grey lighten-1"
                              text
                              @click="newcategorydialog = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              color="primary"
                              class="px-14 py-6 text_trans"
                              @click="send()"
                            >
                              <v-progress-circular
                                indeterminate
                                size="20"
                                class="px-5"
                                color="white"
                                v-show="btnloader"
                              ></v-progress-circular>
                              <span class="pa-4"> Save </span>
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </div>
                    <v-icon @click="organizedialog = false">mdi-close</v-icon>
                  </div>
                  <div>
                    <Organizehelpcenter />
                  </div>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="pa-3">
                      <v-btn
                        class="px-14 py-6 mb-2 text_trans"
                        color="grey lighten-1"
                        text
                        @click="organizedialog = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        color="primary"
                        class="px-14 py-6 mb-2 text_trans"
                        @click="send()"
                      >
                        <v-progress-circular
                          indeterminate
                          size="20"
                          class="px-5"
                          color="white"
                          v-show="btnloader"
                        ></v-progress-circular>
                        <span class="pa-4"> Save </span>
                      </v-btn>
                    </div>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-card>
            <v-card flat class="d-flex align-center">
              <v-btn
                color="white"
                outlined
                dark
                style="background-color: #0071bd; border: 2px solid #0071bd"
                to="/HelpCenter/NewTopic"
                class="text_style"
              >
                + Add New Topic
              </v-btn>
            </v-card>
          </div>
        </v-col>
      </v-row>
      <!----------------- search and filter ---------------------->
      <div class="my-3">
        <v-row class="mt-6">
          <v-col cols="12" md="4" sm="6">
            <v-card flat>
              <v-text-field
                dense
                outlined
                prepend-inner-icon="mdi-magnify"
                label="Search"
                v-model="search"
                @input="filter"
                hide-details
                single-line
              >
              </v-text-field>
            </v-card>
          </v-col>
          <v-col cols="12" md="2" sm="6">
            <v-card
              height="45"
              outlined
              class="px-2 mt-n1 d-flex justify-start align-center"
              style="cursor: pointer"
              @click="filterDialog = true"
            >
              <div
                class="d-flex justify-space-between align-center"
                style="width: 100%"
              >
                <div>
                  <v-icon>mdi-tune</v-icon>
                  <span class="text_style mx-1" style="letter-spacing: 1px"
                    >Filters</span
                  >
                </div>
                <div>
                  <v-icon>mdi-menu-down</v-icon>
                </div>
              </div>
            </v-card>
            <!------------------------fliter diloag------------------------------------------>
            <v-dialog v-model="filterDialog" max-width="430" persistent>
              <v-card class="py-5">
                <v-card-title
                  class="mb-5 d-flex justify-space-between align-center"
                >
                  <div class="text-h5"><b> Filters</b></div>
                  <div>
                    <v-btn text depressed class="pa-0" @click="cleanFilter()">
                      <span class="primary--text" style="letter-spacing: 0px"
                        >Clean filters</span
                      >
                    </v-btn>
                    <v-icon class="ml-3" @click="filterDialog = false"
                      >mdi-close</v-icon
                    >
                  </div>
                </v-card-title>

                <v-card-text>
                  <v-select
                    outlined
                    v-model="filterCategory"
                    :items="filterCategoryList"
                    dense
                    hide-details
                    label="By Category "
                    multiple
                    persistent-hint
                    :menu-props="{ maxHeight: '400' }"
                  ></v-select>

                  <v-select
                    class="my-5"
                    outlined
                    v-model="filterShowhide"
                    :items="filtershowhideList"
                    dense
                    :menu-props="{ maxHeight: '400' }"
                    hide-details
                    label="Show / Hide"
                    persistent-hint
                  ></v-select>
                  <v-select
                    outlined
                    v-model="filterlanguage"
                    :items="filterLanguageList"
                    dense
                    :menu-props="{ maxHeight: '400' }"
                    hide-details
                    label="Language"
                    multiple
                    persistent-hint
                  ></v-select>

                  <!---------------------Type-modalitiy model filter-------------------------------->
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="#646464"
                    outlined
                    depressed
                    class="px-5"
                    text
                    @click="filterDialog = false"
                  >
                    <span class="text_style"> Cancel </span>
                  </v-btn>
                  <v-btn
                    color="primary"
                    class="px-8 ml-2"
                    @click="filterDialog = false"
                    depressed
                  >
                    <span class="text_style"> Save Filters </span>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
      </div>
      <!----------------- data table ---------------------->
      <v-card class="mt-6" outlined>
        <v-data-table
          :headers="headers"
          :loading="tableLoader"
          loading-text="Loading... Please wait"
          :items="Fitems"
          :search="search"
          :page.sync="page"
          :items-per-page="displayedItemsPerPage"
          @page-count="pageCount = $event"
          hide-default-footer
        >
          <template v-slot:[`item.index`]="{ index }">
            <b> {{ index + displayedItemsPerPage * (page - 1) + 1 }} </b>
          </template>

          <template v-slot:[`item.title`]="{ item }">
            <span class="table_style_one"> {{ item.title }} </span>
          </template>
          <template v-slot:[`item.category`]="{ item }">
            <span class="table_style_two"> {{ item.category }} </span>
          </template>
          <template v-slot:[`item.helpful`]="{ item }">
            <span class="table_style_two"> {{ item.helpful }} </span>
          </template>
          <template v-slot:[`item.language`]="{ item }">
            <span class="table_style_two"> {{ item.language }} </span>
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <v-icon color="#EAA413" v-if="item.isHidden"
              >mdi-pin-outline</v-icon
            >
            <v-icon color="transparent" v-else>mdi-pin-outline</v-icon>
            <v-btn icon @click="toggleIsPlaying(item.index)" class="mx-5">
              <v-icon v-if="item.isPlaying" color="primary">mdi-eye</v-icon>
              <v-icon v-else>mdi-eye</v-icon>
            </v-btn>
            <!-- <v-btn icon @click="toggleIsPlaying(item.index)" class="mx-5">
              <v-icon v-if="item.isPlaying" color="primary">mdi-eye</v-icon>
              <v-icon v-else>mdi-eye-off</v-icon>
            </v-btn> -->
            <v-menu
              transition="scroll-y-transition"
              offset-y
              color="transparent"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="A1A1A6" v-bind="attrs" v-on="on" class="mx-3">
                  mdi-dots-horizontal
                </v-icon>
              </template>
              <v-card flat>
                <v-list class="px-3 pt-1" color="transparent">
                  <v-btn
                    depressed
                    color="transparent"
                    block
                    class="d-flex justify-start"
                    to="/HelpCenter/EditTopic"
                  >
                    <v-icon color="#646464">mdi-pencil</v-icon>
                    <span class="ml-4 text_style">Edit</span>
                  </v-btn>
                </v-list>
                <v-list class="px-3 pt-1" color="transparent">
                  <v-dialog v-model="dialog" persistent max-width="290">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        depressed
                        color="transparent"
                        block
                        class="d-flex justify-start"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon color="#646464">mdi-delete</v-icon>
                        <span class="ml-4 text_style">Delete</span>
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title class="text-h5"> Warning </v-card-title>
                      <v-card-text class="index_span_2_style"
                        >Are you sure you want to delete?</v-card-text
                      >
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="green darken-1"
                          text
                          @click="dialog = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          color="red darken-1"
                          text
                          @click="dialog = false"
                        >
                          confirm
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-list>
              </v-card>
            </v-menu>
          </template>
        </v-data-table>
      </v-card>
      <v-card flat class="my-9 d-flex justify-end align-center">
        <span class="text_transform pa-0 ma-0">Per page : </span>
        <v-card flat width="100" class="mx-5">
          <v-select
            :items="ItemsPerPageItems"
            label="Items per page"
            v-model="itemsPerPage"
          ></v-select>
        </v-card>
        <v-pagination
          v-model="page"
          :length="pageCount"
          :total-visible="5"
        ></v-pagination
      ></v-card>
    </div>
  </div>
</template>

<script>
import Organizehelpcenter from "../../components/HelpCenter.vue/Organizehelpcenter.vue";
import HelpcenterimageUploader from "../../components/HelpCenter.vue/helpcenterimageUploader.vue";

export default {
  data() {
    return {
      filterDialog: false,
      ItemsPerPageItems: [10, 50, 100, 200, "All"],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      valid: false,
      dialog: false,
      isPlaying: false,
      editvideodialog: false,
      newcategorydialog: false,
      organizedialog: false,
      SeeProfileDialog: false,
      tableLoader: false, // data-table true or false
      add_dialog: false,
      btnloader: false,
      test: true,
      NameCategory: "",
      Language: "",
      search: "",

      headers: [
        { text: "#", value: "index" },
        { text: "Title", value: "title" },
        { text: "Category", value: "category" },
        { text: "Helpful", value: "helpful" },
        { text: "Language", value: "language" },
        { text: "", value: "actions", sortable: false },
      ],
      DataTableOne: [],
      Fitems: [],
      filterShowhide: [],
      filtershowhideList: ["Show", "Hide"],
      filterLanguage: [],
      filterLanguageList: [
        "English",
        "French",
        "German",
        "Japanese",
        "Italian",
        "Portuguese",
        "Filipino",
        "Spanish",
        "Chinese",
        "Russian",
      ],
    };
  },
  mounted() {
    this.tableLoader = true;
    setTimeout(() => {
      (this.DataTableOne = [
        {
          index: 123,
          title: "The video quality is not very good, what do I do?",
          category: "First Time Visitors",
          helpful: "121",
          language: "English",
          isPlaying: false,
        },
        {
          index: 1,
          title: "What is LiveStream?",
          category: "IBA Modalities",
          helpful: "121",
          language: "Portuguese",
          isPlaying: false,
        },
        {
          index: 2,
          title: "The video quality is not very good, what do I do?",
          category: "IBA Modalities",
          helpful: "121",
          language: "Portuguese",
          isPlaying: false,
        },
        {
          index: 3,
          title: "The video quality is not very good, what do I do?",
          category: "First Time Visitors",
          helpful: "121",
          language: "Portuguese",
          isPlaying: false,
        },
        {
          index: 4,
          title: "What is LiveStream?",
          category: "First Time Visitors",
          helpful: "121",
          language: "English",
          isPlaying: false,
        },
        {
          index: 5,
          title: "¿Que es un directo?",
          category: "First Time Visitors",
          helpful: "121",
          language: "Spanish",
          isPlaying: false,
        },
        {
          index: 6,
          title: "The video quality is not very good, what do I do?",
          category: "First Time Visitors",
          helpful: "121",
          language: "English",
          isPlaying: false,
        },
        {
          index: 7,
          title: "The video quality is not very good, what do I do?",
          category: "First Time Visitors",
          helpful: "121",
          language: "English",
          isPlaying: false,
        },
        {
          index: 8,
          title: "The video quality is not very good, what do I do?",
          category: "First Time Visitors",
          helpful: "121",
          language: "English",
          isPlaying: false,
        },
        {
          index: 9,
          title: "The video quality is not very good, what do I do?",
          category: "First Time Visitors",
          helpful: "121",
          language: "English",
          isPlaying: false,
        },
      ]),
        (this.Fitems = this.DataTableOne);
      this.tableLoader = false;
    }, 5000);
  },
  computed: {
    displayedItemsPerPage() {
      return this.itemsPerPage === "All"
        ? this.Fitems.length
        : this.itemsPerPage;
    },
  },
  methods: {
    toggleIsPlaying(obj) {
      this.DataTableOne = this.DataTableOne.map((e) => {
        if (e.index === obj) {
          e.isPlaying = !e.isPlaying;

          return e;
        }
        return e;
      });
      this.isPlaying = !this.isPlaying;
    },
    send() {
      setTimeout(() => {
        this.btnloader = true;
      }, 100);
      setTimeout(() => {
        this.organizedialog = false;
        this.btnloader = false;
        this.newcategorydialog = false;
        this.editvideodialog = false;
      }, 2000);
    },
  },
  components: {
    Organizehelpcenter,
    HelpcenterimageUploader,
  },
};
</script>
<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: #e0e0e0;
}
.text_trans {
  text-transform: none;
}
</style>
